"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLabel = exports.removeLabel = exports.moveToSplit = exports.markAsSpam = exports.discardDraft = exports.notSpam = exports.deleteForever = exports.untrash = exports.trash = exports.unread = exports.read = exports.unarchive = exports.archive = void 0;

var _react = _interopRequireDefault(require("react"));

var _i18next = _interopRequireDefault(require("i18next"));

var _Drafts = _interopRequireDefault(require("@material-ui/icons/Drafts"));

var _Mail = _interopRequireDefault(require("@material-ui/icons/Mail"));

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _DeleteForever = _interopRequireDefault(require("@material-ui/icons/DeleteForever"));

var _Unarchive = _interopRequireDefault(require("@material-ui/icons/Unarchive"));

var _Report = _interopRequireDefault(require("@material-ui/icons/Report"));

var _ReportOff = _interopRequireDefault(require("@material-ui/icons/ReportOff"));

var _LabelOff = _interopRequireDefault(require("@material-ui/icons/LabelOff"));

var _Label = _interopRequireDefault(require("@material-ui/icons/Label"));

var archive = {
  name: 'archive',
  icon: /*#__PURE__*/_react["default"].createElement(_Done["default"], null),
  title: _i18next["default"].t('thread.actions.archive')
};
exports.archive = archive;
var unarchive = {
  name: 'unarchive',
  icon: /*#__PURE__*/_react["default"].createElement(_Unarchive["default"], null),
  title: _i18next["default"].t('thread.actions.unarchive')
};
exports.unarchive = unarchive;
var read = {
  name: 'read',
  icon: /*#__PURE__*/_react["default"].createElement(_Drafts["default"], null),
  title: _i18next["default"].t('thread.actions.read')
};
exports.read = read;
var unread = {
  name: 'unread',
  icon: /*#__PURE__*/_react["default"].createElement(_Mail["default"], null),
  title: _i18next["default"].t('thread.actions.unread')
};
exports.unread = unread;
var trash = {
  name: 'trash',
  icon: /*#__PURE__*/_react["default"].createElement(_Delete["default"], null),
  title: _i18next["default"].t('thread.actions.trash')
};
exports.trash = trash;
var untrash = {
  name: 'untrash',
  icon: /*#__PURE__*/_react["default"].createElement(_Unarchive["default"], null),
  title: _i18next["default"].t('thread.actions.untrash')
};
exports.untrash = untrash;
var deleteForever = {
  name: 'deleteForever',
  icon: /*#__PURE__*/_react["default"].createElement(_DeleteForever["default"], null),
  title: _i18next["default"].t('thread.actions.deleteForever')
};
exports.deleteForever = deleteForever;
var notSpam = {
  name: 'notSpam',
  icon: /*#__PURE__*/_react["default"].createElement(_ReportOff["default"], null),
  title: _i18next["default"].t('thread.actions.notSpam')
};
exports.notSpam = notSpam;
var discardDraft = {
  name: 'discardDraft',
  icon: /*#__PURE__*/_react["default"].createElement(_Delete["default"], null),
  title: _i18next["default"].t('thread.actions.discardDraft')
};
exports.discardDraft = discardDraft;
var markAsSpam = {
  name: 'markAsSpam',
  icon: /*#__PURE__*/_react["default"].createElement(_Report["default"], null),
  title: _i18next["default"].t('thread.actions.markAsSpam')
};
exports.markAsSpam = markAsSpam;
var moveToSplit = {
  name: 'moveToSplit',
  icon: /*#__PURE__*/_react["default"].createElement(_Label["default"], null),
  title: _i18next["default"].t('thread.actions.moveToSplit')
};
exports.moveToSplit = moveToSplit;
var removeLabel = {
  name: 'removeLabel',
  icon: /*#__PURE__*/_react["default"].createElement(_LabelOff["default"], null),
  title: _i18next["default"].t('thread.actions.removeLabel')
};
exports.removeLabel = removeLabel;
var addLabel = {
  name: 'addLabel',
  icon: /*#__PURE__*/_react["default"].createElement(_Label["default"], null),
  title: _i18next["default"].t('thread.actions.addLabel')
};
exports.addLabel = addLabel;
//# sourceMappingURL=thread-actions.js.map